import { User } from '@segment/analytics-next'
import z from 'zod'
import { convertJsonSchemaToZod, JSONSchema } from 'zod-from-json-schema'
import { EventKeysType, EVENT_REGISTRY } from './segment-events'
import { SegmentUser } from './segment.types'
import { isZodSchema } from '@/utils/zod/zod-utils'

const schemaCache: Partial<Record<EventKeysType, z.ZodTypeAny>> = {}

// Optional utility to get the Zod schema for a specific event key
// Not required in the current approach, but can be useful for future updates
export const getSegmentEventSchema = (key: EventKeysType): z.ZodTypeAny | undefined => {
  if (schemaCache[key]) return schemaCache[key]
  const meta = EVENT_REGISTRY[key]

  if (!meta?.schema) return undefined

  const zod = isZodSchema(meta.schema)
    ? meta.schema
    : convertJsonSchemaToZod(meta.schema as JSONSchema)

  schemaCache[key] = zod

  return zod
}

export const adaptToSegmentUser = (user?: User): SegmentUser | null => {
  const userId = Number(user?.id?.())
  const additionalProperties = user?.traits?.() || {}

  if (!userId || isNaN(userId)) return null

  return {
    userId,
    ...additionalProperties,
  } as SegmentUser
}
